import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

const SEV = {
  info: "text-primary",
  warning: "text-yellow-500",
  error: "text-destructive",
};

export default function AuditLog() {
  const { data } = useQuery({
    queryKey: ["audit"],
    queryFn: async () => (await api.get("/audit")).data,
    refetchInterval: 15000,
  });

  const entries = data?.entries || [];

  return (
    <div className="border border-border rounded-sm bg-card max-w-5xl" data-testid="audit-table">
      <div className="flex items-center justify-between px-6 py-4 border-b border-border">
        <h2 className="text-sm font-medium">Recent Activity</h2>
        <span className="font-mono text-[10px] uppercase tracking-[0.12em] text-muted-foreground">
          {entries.length} entries
        </span>
      </div>
      <Table>
        <TableHeader>
          <TableRow className="border-border hover:bg-transparent">
            <TableHead className="font-mono text-[10px] uppercase tracking-[0.1em] text-muted-foreground">Time</TableHead>
            <TableHead className="font-mono text-[10px] uppercase tracking-[0.1em] text-muted-foreground">Action</TableHead>
            <TableHead className="font-mono text-[10px] uppercase tracking-[0.1em] text-muted-foreground">Actor</TableHead>
            <TableHead className="font-mono text-[10px] uppercase tracking-[0.1em] text-muted-foreground">Detail</TableHead>
            <TableHead className="font-mono text-[10px] uppercase tracking-[0.1em] text-muted-foreground">Severity</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {entries.map((e, i) => (
            <TableRow key={i} className="border-border hover:bg-white/[0.02]" data-testid="audit-row">
              <TableCell className="font-mono text-[11px] text-muted-foreground whitespace-nowrap">
                {new Date(e.timestamp).toLocaleString()}
              </TableCell>
              <TableCell className="font-mono text-xs text-white">{e.action}</TableCell>
              <TableCell className="font-mono text-xs text-muted-foreground">{e.actor}</TableCell>
              <TableCell className="text-xs text-muted-foreground max-w-xs truncate">{e.detail}</TableCell>
              <TableCell className={`font-mono text-[11px] uppercase ${SEV[e.severity] || "text-muted-foreground"}`}>
                {e.severity}
              </TableCell>
            </TableRow>
          ))}
          {entries.length === 0 && (
            <TableRow>
              <TableCell colSpan={5} className="text-center text-sm text-muted-foreground py-10">
                No activity recorded yet.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
